import './style.scss';
import register from 'ShopUiBundle/modules/app/registry';

// tslint:disable-next-line
register('catalog-filter-dropdown', () => import(/* webpackMode: "lazy" */'./catalog-filter-dropdown'));
